// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1_qqe","text":"SelectPayment_text__3V3Hj","title":"SelectPayment_title__BJNbM","btn":"SelectPayment_btn__3h_uJ"};